import { apiFloristGatewayService } from './apiService/HttpService';
import { setEndPoint } from './apiService/SetEndPoint';
import { endPoints } from './apiService/EndPoints';

class AvailabilityService {
  static getAvailability() {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.availability),
    });
  }

  static setAvailability(online) {
    return apiFloristGatewayService({
      method: 'PUT',
      url: setEndPoint(endPoints.availability),
      data: { online },
    });
  }
}

export default AvailabilityService;
